import { useEffect, useState } from "react";
import { _BudgetSheetFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { MASK_MONEY } from "../../theme/Component/BasicTable2";
import { SelectBudgetResource } from "../../contract/select/SelectBudgetResource";
import { FileInput } from "../../theme/Component/FileInput";
import { ErrorList } from "../../theme/Component/ErrorList";
import { InputMoney } from "../../theme/Input/InputMoney";
import { SelectBudgetSource } from "../../admin/configuracion/BudgetSource/SelectBudgetSource";
import { SelectBudgetStructure } from "../../admin/configuracion/BudgetStructure/SelectBudgetStructure";
import { PrintJson } from "../../theme/Component/PrintJson";
import { BudgetDisaggregation } from "./BudgetDisaggregation";
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal";


interface Props {
    sheetForm: any;
    onChange: Function;
}

export const RegisterSheetBudgetValue = ({ sheetForm, onChange }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_BudgetSheetFactory);
    const [initBean, setInitBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [doc, setDoc] = useState<any>({});
    const [structure, setStructure] = useState<number>(null);
    const [msgList, setMsgList] = useState<any>([]);
    const [items, setItems] = useState<any>([]);


    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalImp, setModalImp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalDesagregation = useModal("Desagregación Presupuetal", MODAL_XL);

    useEffect(() => {
        getLista();
    }, [sheetForm])

    const getLista = () => {
        instance.getInitialBudgetIDCatalog(sheetForm.Year, sheetForm.IDBudgetType, _single.getAccountID()).then(
            (resp) => {
                setLista(resp.reverse());
                setMsgList([]);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'Código', property: 'BudgetIDStr', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fuente de Recurso', property: 'BudgetSourceName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Valor Presupuesto', property: 'Value', visible: true, mask: MASK_MONEY },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar" }) } },
            { titulo: 'Desagregar Rubro', icono: 'ri-pie-chart-line', visible: _single.canEdit(), evento: () => { modalDesagregation.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { eliminarItem() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createItem = () => {
        setBean({});
        setModal({ ...modal, "view": true, "name": "Crear" })
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: createItem },
        { nombre: 'Importar', visible: _single.canCreate(), icono: 'ri-folder-add-fill', evento: () => { setModalImp({ ...modalImp, "view": true, "name": "Agregar a la tabla Presupuesto Inicial desde archivo" }) } }
    ]

    const importItems = () => {
        setMsgList([]);
        instance.importInitialBudgetRows(sheetForm.IDBudgetIDType, doc.Media, doc.MediaContext, null, structure).then(
            (resp) => {
                console.log(resp)
                setStructure(null)
                setMsgList(resp.ErrorList)
                setLista(resp.BudgetList)
                setModalImp({ ...modalImp, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const createNewItem = () => {

        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        instance.createInitialBudgetRowList(sheetForm.IDBudgetIDType, bean.BudgetIDStr, bean.IDBudgetSource, bean.IDBudgetResource, bean.Value, bean.Description, bean.AdquisitionItemList ?? []).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModal({ ...modal, "view": false });
                modalDesagregation.close();
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const setRowBean = (object: any) => {
        setBean(object);
        setInitBean(object)
        if (object.AdquisitionItemList) {
            setItems(object.AdquisitionItemList);
        } else {
            setItems([]);
        }
    }

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createNewItem();
        }
    }



    const validateForm = () => {
        const requiredFields = [
            "Value", "BudgetIDStr", "IDBudgetResource", "IDBudgetSource"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };

    useEffect(() => {
        onChange(lista);
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setRowBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
            </div>

            {msgList.length > 0 &&
                <div className="col-md-12 mt-2">
                    <ErrorList lista={msgList} />
                </div>
            }

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDBudgetResource') ? 'has-error' : ''}`}>Recurso Presupuestal</label>
                            <SelectBudgetResource idSelector={bean.IDBudgetResource} onChange={(e) => { setBean({ ...bean, "IDBudgetResource": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDBudgetSource') ? 'has-error' : ''}`}>Fuente de Financiamiento</label>
                            <SelectBudgetSource idSelector={bean.IDBudgetSource} onChange={(e) => { setBean({ ...bean, "IDBudgetSource": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('BudgetIDStr') ? 'has-error' : ''}`}>Rubro Presupuestal</label>
                            {/* <SelectExpensiveBudgetIDType idSelector={} onChange={} year={} /> */}
                            <SelectBudgetID label=" " jsonCode={bean.BudgetIDStr} onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} edit={false} _year={sheetForm.Year} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                            <InputMoney _label=" " _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>

                        {/* <PrintJson json={bean}/> */}
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalImp} updateModal={setModalImp} eventModal={importItems} >
                    <div className="row">
                        <div className="col-md-12">
                            <SelectBudgetStructure idSelector={structure} onChange={(e) => { setStructure(e) }} />
                        </div>
                        <div className="col-md-12">
                            <FileInput onCreate={(e) => { setDoc(e) }} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalDesagregation.modal} updateModal={modalDesagregation.setModal} eventModal={validateData} onSubmitLabel="Agregar">
                    <div className="row">
                        <div className="col-md-12">
                            <BudgetDisaggregation budgetLine={bean} listAdquisitionItem={bean.AdquisitionItemList} updateAdquisitionItemList={(e) => { setBean({ ...bean, "AdquisitionItemList": e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}